module.exports = __webpack_public_path__ + "static/media/exlam-circle-yellow.7790a6f2.svg";